export default function Portfolio() {
  const images = [
    "/portfolio/bmw.jpeg",
    "/portfolio/birthday.jpeg",
    "/portfolio/highway-vaal.jpeg",
    "/portfolio/oudtshoorn.jpeg",
    "/portfolio/pharmacy.jpeg",
    "/portfolio/south-africa.jpeg",
  ];

  return (
    <section
      id="portfolio"
      className="bg-[#0b0f16] py-24 text-white"
    >
      <div className="max-w-7xl mx-auto px-6">

        <h2 className="text-5xl font-black text-center mb-4">
          OUR RECENT WORK
        </h2>

        <p className="text-center text-gray-400 mb-16">
          Take a look at some of our latest custom printing projects.
        </p>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">

          {images.map((image, index) => (

            <div
              key={index}
              className="group overflow-hidden rounded-3xl border border-sky-500/20"
            >

              <img
                src={image}
                alt=""
                className="w-full h-80 object-cover rounded-3xl"
              />

            </div>

          ))}

        </div>

      </div>
    </section>
  );
}